import { servicesAsync } from 'Common/environment/environment'

import genericClient from './genericFetchClient'

export type { RequestConfig, ResponseErrorConfig, ResponseConfig } from './genericFetchClient'

const resolveBaseUrl = async () => {
    const identity = await servicesAsync.identity('')
    try {
        return new URL(identity).origin
    } catch {
        return identity
    }
}

const client = await genericClient(await resolveBaseUrl())

export default client
